import React from "react";

const HrIcon = ({ iconSize, strokeColor, className = "" }) => {

  return (
    <svg
      width={iconSize}
      height={iconSize}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.4219 4.76946C10.6023 4.70256 10.7975 4.66602 11.0012 4.66602C11.9217 4.66602 12.6679 5.41221 12.6679 6.33268C12.6679 7.25315 11.9217 7.99935 11.0012 7.99935C10.7975 7.99935 10.6023 7.96282 10.4219 7.89588"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M2 12.666C2.46091 11.1279 3.64665 10.666 6.33333 10.666C9.02 10.666 10.2057 11.1279 10.6667 12.666"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M11.332 10C12.934 10.0633 13.6848 10.4255 13.9987 11.3333"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M8.66667 6.33333C8.66667 7.622 7.622 8.66667 6.33333 8.66667C5.04467 8.66667 4 7.622 4 6.33333C4 5.04467 5.04467 4 6.33333 4C7.622 4 8.66667 5.04467 8.66667 6.33333Z"
        stroke={strokeColor}
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default HrIcon;
